import { connect } from "react-redux";

import ErrorBoundary from "../../components/errorBoundary";

// SmartErrorBoundary is a wrapper around our ErrorBoundary class to supply it with the redux store if no
// other store prop is passed in.

const mapStateToProps = (state, props) => {
  return {
    store: props.store ? props.store : state.present
  };
};

export default connect(mapStateToProps, null)(ErrorBoundary);
